<template>
  <v-container fluid grid-list-md>
    
    <v-layout row wrap>

      <v-flex xs12 class="display-1 font-weight-light">
          FEATURED ASSESSMENTS
      </v-flex>

      <v-flex xs12 sm4>

        <v-card height="100%">
          <v-img
            height="100%"
            :src="image"
            :lazy-src="image"
          ><template v-slot:placeholder>
                    <v-layout
                      fill-height
                      align-center
                      justify-center
                      ma-0
                    >
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-layout>
                  </template>
          </v-img>
        </v-card>

      </v-flex>

      <v-flex xs12 sm8>
          <p>FLLI provides a diverse array of assessments to assist leaders in developing self-awareness to leverage their strengths and mitigate their weaknesses. The assessments currently used in the FLLI curriculum are detailed below, with each also available as part of a customized training event or as stand-alone administration. Group and/or individual debriefs are available and will provide an in-depth look at output, allowing participants to take actions based on the assessment results.</p>
      </v-flex>


	
  
      <template v-for="(item,index) in assessmentsData">

        <v-flex xs12 md6 :key="index">
          <v-card color="light-blue darken-1" dark height="100%" class="card-block">

            <v-card-title>
              <div>{{ item.title }}</div>
            </v-card-title>            

              <v-card-text class="white text--primary">
                  <div class="title text--primary">{{item.subtitle}}</div>
                  <template v-for="(item2, index2) in item.content">
                    <p :key="index2">{{item2}}</p>
                  </template>
                  <ul v-for="(item3, index3) in item.bullets">
                    <li>{{item3}}</li>
                  </ul>
                  <p></p>
                  <p v-if="item.extraContent">{{item.extraContent}}</p>
              </v-card-text>

              <v-spacer class="white"></v-spacer>

            </v-card>
        </v-flex>
      </template>

    </v-layout>
   
  </v-container>
</template>

<script>
import assessmentsJson from '@/json/featured_assessments.json'

  export default {
    data () {
        return {
          assessmentsData: assessmentsJson,
          image: require('@/assets/ThinkstockPhotos-516589445.jpg')
        }
    }
  }
</script>

<style>
.flexcard {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.card-block {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
</style>
